import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState('enter');

  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) { onComplete(); return; }

    const showTimer = setTimeout(() => setPhase('exit'), 1600);
    const doneTimer = setTimeout(() => onComplete(), 2200);
    return () => { clearTimeout(showTimer); clearTimeout(doneTimer); };
  }, [onComplete]);

  return (
    <div className={`splash ${phase}`} data-testid="splash-screen" aria-live="polite" aria-label="Loading D Soto Cleaning">
      <div className="splash-inner">
        <img
          src="https://customer-assets.emergentagent.com/job_dsoto-corporate/artifacts/tp4zyo79_D%20Soto%20Cleaning%20Logo%20Color%202.png"
          alt="D Soto Cleaning"
          className="splash-logo"
          draggable={false}
        />
        <div className="splash-bar-track">
          <div className="splash-bar-fill" />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
